/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PortDTO { 
    id?: number;
    unloCode?: string;
    iataCode?: string;
    countryName?: string;
    portType?: PortDTO.PortTypeEnum;
    name?: string;
    countryId?: number;
    isBlocked?: boolean;
    isDeleted?: boolean;
    masterDataStatus?: PortDTO.MasterDataStatusEnum;
}
export namespace PortDTO {
    export type PortTypeEnum = 0 | 1;
    export const PortTypeEnum = {
        NUMBER_0: 0 as PortTypeEnum,
        NUMBER_1: 1 as PortTypeEnum
    };
    export type MasterDataStatusEnum = 0 | 1;
    export const MasterDataStatusEnum = {
        NUMBER_0: 0 as MasterDataStatusEnum,
        NUMBER_1: 1 as MasterDataStatusEnum
    };
}